var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('zj-layout-container',[_c('zj-layout-header',[_c('div',{staticClass:"listtitle"},[_vm._v("关于系统")]),_c('el-divider')],1),_c('zj-layout-main',[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"mapBox"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }